export default "__VITE_ASSET__IQg16xoD__"